import { createContext, useContext } from 'react';

export const ClientContext = createContext();

export const useClientContext = () => useContext(ClientContext);

export default ClientContext;
